export const MAX_ROLES_COUNT = 15;

export const REQUIRED_ROLE = 'MANAGE_USERS';
